import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Close } from "@air/next-icons";
import { Button } from "@air/primitive-button";
import { IconButton } from "@air/primitive-icon-button";
import classNames from "classnames";
import { memo } from "react";
import { ASSET_MODAL_KEYWORD } from "~/constants/testIDs";
export const REMOVE_SMART_TAG_BUTTON = "REMOVE_SMART_TAG_BUTTON";
export const KEYWORD_REMOVE_ICON = "KEYWORD_REMOVE_ICON";
export const InfoPanelSummaryKeywordList = /*#__PURE__*/ memo((param)=>{
    let { keywords, onKeywordClick, onRemoveKeyword } = param;
    if (!(keywords === null || keywords === void 0 ? void 0 : keywords.length)) return null;
    return /*#__PURE__*/ _jsx("div", {
        className: "flex flex-wrap items-baseline gap-1.5 space-y-2 pb-2",
        children: keywords.map((keyword)=>/*#__PURE__*/ _jsxs("div", {
                className: "group relative",
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        "data-testid": "".concat(ASSET_MODAL_KEYWORD, "-").concat(keyword.label),
                        appearance: "outline",
                        size: "small",
                        color: "grey",
                        className: classNames("rounded-full", {
                            "pr-5": !!onRemoveKeyword
                        }),
                        onClick: onKeywordClick ? ()=>onKeywordClick === null || onKeywordClick === void 0 ? void 0 : onKeywordClick(keyword.label) : undefined,
                        children: keyword.label
                    }),
                    !!onRemoveKeyword && /*#__PURE__*/ _jsx(IconButton, {
                        label: "Remove smart tag",
                        "data-testid": KEYWORD_REMOVE_ICON,
                        appearance: "ghost",
                        size: "small",
                        color: "grey",
                        className: "absolute right-1 top-1/2 size-4 -translate-y-1/2 p-0",
                        onClick: ()=>onRemoveKeyword(keyword),
                        children: /*#__PURE__*/ _jsx(Close, {
                            className: "size-3"
                        })
                    })
                ]
            }, keyword.id))
    });
});
InfoPanelSummaryKeywordList.displayName = "InfoPanelSummaryKeywordList";
